import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row gap-4 justify-between items-center" }
const _hoisted_2 = { class: "text-[22px] leading-none font-bold" }

import PostsLimit from '../posts/PostsLimit.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageHeading',
  props: {
    heading: {},
    showPostsLimit: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.heading), 1),
    (_ctx.showPostsLimit)
      ? (_openBlock(), _createBlock(PostsLimit, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})